import * as types from './types';

const initialState = {
  loading: false,
  mensajeErrorLoading: null,
  eventos: null,
  totalItems: 0,
  evento: null,
  updating: false,
  mensajeErrorUpdating: null,
  updateSuccess: false,
  loadingQR: false,
  mensajeErrorLoadingQR: null,
  eventoQR: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_EVENTOS_LIST_START:
      return {
        ...state,
        mensajeErrorLoading: null,
        loading: true,
        updateSuccess: false,
      };
    case types.DOWNLOAD_QR_EVENTO_START:
      return {
        ...state,
        mensajeErrorLoadingQR: null,
        loadingQR: true,
      };
    case types.GET_EVENTO_START:
    case types.CREATE_EVENTO_START:
    case types.UPDATE_EVENTO_START:
    case types.UPLOAD_FILE_EVENTO_START:
    case types.DELETE_EVENTO_START:
      return {
        ...state,
        mensajeErrorUpdating: null,
        updateSuccess: false,
        updating: true,
      };
    case types.GET_EVENTOS_LIST_ERROR:
      return {
        ...state,
        loading: false,
        mensajeErrorLoading: payload,
      };
    case types.DOWNLOAD_QR_EVENTO_ERROR:
      return {
        ...state,
        mensajeErrorLoadingQR: payload,
        loadingQR: false,
      };
    case types.GET_EVENTO_ERROR:
    case types.CREATE_EVENTO_ERROR:
    case types.UPLOAD_FILE_EVENTO_ERROR:
    case types.UPDATE_EVENTO_ERROR:
    case types.DELETE_EVENTO_ERROR:
      return {
        ...state,
        updating: false,
        updateSuccess: false,
        mensajeErrorUpdating: payload,
      };
    case types.GET_EVENTOS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        eventos: payload.data,
        totalItems: parseInt(payload.headers['x-total-count'], 10),
      };
    case types.DOWNLOAD_QR_EVENTO_SUCCESS:
      return {
        ...state,
        mensajeErrorLoadingQR: null,
        loadingQR: false,
        eventoQR: payload.data,
      };
    case types.GET_EVENTO_SUCCESS:
    case types.CREATE_EVENTO_SUCCESS:
    case types.UPDATE_EVENTO_SUCCESS:
    case types.UPLOAD_FILE_EVENTO_SUCCESS:
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        evento: payload.data,
      };
    case types.DELETE_EVENTO_SUCCESS:
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        evento: initialState.evento,
      };
    case types.RESET:
      return {
        ...initialState,
      };
    case types.RESET_EVENTO:
      return {
        ...state,
        evento: initialState.paciente,
      };
    default:
      return state;
  }
};
